import React, { SVGProps } from 'react';

const SvgChevronRight = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height="16"
			viewBox='0 0 24 24'
			width="16"
			fill='currentColor'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6-6-6z' />
		</svg>
	);
}

export default SvgChevronRight;

